import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-2 pb-2 text-left" }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "mt-2 pb-2 text-left" }
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = { class: "mt-1" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "mt-2 pb-2 text-left" }
const _hoisted_14 = { class: "text-sm" }
const _hoisted_15 = { class: "mt-1" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "mt-2 pb-2 text-left" }
const _hoisted_18 = { class: "text-sm" }
const _hoisted_19 = { class: "mt-1" }
const _hoisted_20 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" }

import { computed, inject, onMounted, ref, watch } from "vue";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
  Switch,
} from "@headlessui/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OperatorTierConfigDialog',
  props: { form: Object, show: Boolean },
  emits: [
  "topup",
  "update:show",
  "update:form",
  "operatorUpdate",
],
  setup(__props, { emit }) {

const props = __props

const store = useStore();
const axios = inject("$axios") as AxiosInstance;
const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});

const opratorTierConfig = ref({
  id: "",
  // duration: 0,
  name: "",
  operator_id: "",
  is_active: false,
  start_date: "",
  end_date: "",
});

const updateOperatorConfig = async () => {
  await axios.post(
    `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/cms/oper-tiers/update`,
    {
      operator_id: opratorTierConfig.value.id
        ? undefined
        : store.state.selectedOperator.operatorId,
      id: opratorTierConfig.value.id ? opratorTierConfig.value.id : undefined,
      is_active: opratorTierConfig.value.is_active,
      start_date: opratorTierConfig.value.start_date,
      end_date: opratorTierConfig.value.end_date,
      // duration: opratorTierConfig.value.duration,
      name: opratorTierConfig.value.name,
    }
  );
  emit("operatorUpdate");
  showSync.value = false;
};

const fetchOperatorTierSystemConfig = async () => {
  const { data } = await axios.post(
    `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/cms/oper-tiers/details`,
    { operator_id: store.state.selectedOperator.operatorId }
  );
  if (data) {
    opratorTierConfig.value = data;
    console.log("opratorTierConfig : ",opratorTierConfig.value)
  }
};
onMounted(async () => {
  await fetchOperatorTierSystemConfig();
});




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: _unref(showSync)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        static: "",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _cache[6] || (_cache[6] = ($event: any) => (showSync.value = false)),
        open: _unref(showSync)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(DialogTitle), {
                        as: "h3",
                        class: "text-lg leading-6 font-medium text-gray-900"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("messages.playerTier.operatorTierConfig")), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("messages.playerTier.name")), 1),
                        _createElementVNode("div", _hoisted_7, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "username",
                            id: "username",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((opratorTierConfig.value.name) = $event)),
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md",
                            placeholder: _ctx.$t('messages.playerTier.name')
                          }, null, 8, _hoisted_8), [
                            [_vModelText, opratorTierConfig.value.name]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("messages.playerTier.startDate")), 1),
                        _createElementVNode("div", _hoisted_11, [
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            name: "username",
                            id: "username",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((opratorTierConfig.value.start_date) = $event)),
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md",
                            placeholder: _ctx.$t('messages.summaryReport.username')
                          }, null, 8, _hoisted_12), [
                            [_vModelText, opratorTierConfig.value.start_date]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("messages.playerTier.endDate")), 1),
                        _createElementVNode("div", _hoisted_15, [
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            name: "username",
                            id: "username",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((opratorTierConfig.value.end_date) = $event)),
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md",
                            placeholder: _ctx.$t('messages.summaryReport.username')
                          }, null, 8, _hoisted_16), [
                            [_vModelText, opratorTierConfig.value.end_date]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("messages.playerTier.activationStatus")), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_unref(Switch), {
                            modelValue: opratorTierConfig.value.is_active,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((opratorTierConfig.value.is_active) = $event)),
                            class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", 
                        opratorTierConfig.value.is_active
                          ? 'bg-blue-400'
                          : 'bg-red-500'
                      ])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                class: _normalizeClass([
                          opratorTierConfig.value.is_active
                            ? 'translate-x-6'
                            : 'translate-x-1'
                        , "inline-block h-4 w-4 transform rounded-full bg-white"])
                              }, null, 2)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "class"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (updateOperatorConfig()))
                    }, _toDisplayString(_ctx.$t("messages.playerTier.updateTierConfig")), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (showSync.value = false)),
                      class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                    }, _toDisplayString(_ctx.$t("messages.playerTier.cancel")), 1)
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})